<wide-dialog-wrapper
  [backgroundColor]="'#9FC5E8'"
  [dialogTitle]="'Manage Budget ' + ( data.isTasks ? 'Task' : 'Asset') + ' Section'"
  [disabled]="!hasChanged"
  [deleteTitle]="'REMOVE'"
  [deleteText]="'Remove ' + this.data.isTasks ? 'tasks' : 'assets' + ' section from the budget'"
  [delete]="true"
  [midRightLabel]="'CANCEL'"
  [successLabel]="'SAVE'"
  (onMidRight)="cancel()"
  (onSubmit)="save()"
  (onDelete)="delete()"
>
  <tip-text [type]="'tip'" [head]="'Tip:'" [body]="'One one ' + (data.isTasks ? 'TASKS' : 'ASSETS') + ' section can be added.'"></tip-text>
  <budget-section *ngIf="!!section && !!budget && !!gridData"
    [section]="section"
    [budgetCurrency]="budget.currency"
    [isRevenue]="false"
    [canDeleteLines]="false"
    [canAddLines]="false"
    [canAddItems]="true"
    [single]="true"
    [gridData]="gridData"
    [isToggleSection]="true"
    [lockQuantityColumn]="data.isTasks"
    [scheduleGridData]="scheduleGridData"
    (saveSection)="updateSection()"
    (changeSectionSettingDefaults)="saveSectionSettingDefaults($event)"
    (addItem)="addItem($event)"
  ></budget-section>

</wide-dialog-wrapper>

